$(function(){
    $('.b-read-also__articles').each(function(){
        var slider = $(this),
            settings = {
                slidesToShow: 2,
                mobileFirst: true,
                dots: false,
                arrows: false,
                responsive: [
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 3
                        }

                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 4
                        }

                    },
                    {
                        breakpoint: 1024,
                        settings: "unslick"

                    }
                ]
            };
        slider.slick(settings);

        $(window).on('resize', function() {
            if( $(window).width() < 1025 && !slider.hasClass('slick-initialized')) {
                slider.slick(settings);
            }
        });
    })
})